import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import MenuPage from './pages/MenuPage';
import { muiTheme } from './styles/muiTheme';
import { colors, typography } from './styles/theme';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-family: ${typography.fontFamily.primary};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    background: ${colors.background};
    color: ${colors.textPrimary};
    font-size: ${typography.fontSize.md};
    line-height: ${typography.lineHeight.normal};
    overflow-x: hidden;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${typography.fontFamily.heading};
    font-weight: ${typography.fontWeight.bold};
  }

  #root {
    min-height: 100vh;
  }

  button {
    font-family: inherit;
    border: none;
    outline: none;
    cursor: pointer;
  }

  input {
    font-family: inherit;
    border: none;
    outline: none;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  a {
    color: ${colors.primary};
    text-decoration: none;
  }

  // Mobile viewport optimizations
  @media (max-width: 768px) {
    html {
      font-size: 14px;
    }
  }

  // iOS Safari specific fixes
  @supports (-webkit-touch-callout: none) {
    body {
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }

    input, textarea, select {
      -webkit-user-select: text;
      -khtml-user-select: text;
      -moz-user-select: text;
      -ms-user-select: text;
      user-select: text;
    }
  }
`;

function App() {
  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <GlobalStyle />
      <Router>
        <Routes>
          <Route path="/" element={<MenuPage />} />
          {/* В будущем добавим другие маршруты */}
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
